import {
  routeForFinanceHome,
  routeForHome,
  routeForLogin,
} from '@watershed/shared-universal/dashboardRoutes';

import { useUserContext } from './UserContext';

export function useRootRedirect(): string {
  const userContext = useUserContext();

  if (userContext.hasInitialized === false) {
    return routeForLogin();
  }

  if (userContext.canAccessFinance && !userContext.canAccessCorporate) {
    return routeForFinanceHome({}).pathname;
  }

  return routeForHome();
}
